import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import EditIcon from 'transfix-icons/build/EditIcon'
import { Card } from 'transfix-ui/components/Card'
import { IconButton } from 'transfix-ui/components/IconButton'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Typography } from 'transfix-ui/core'
import { ICarrierVinState } from 'types/carrier'
import { getCarrierVins, showVinsDialog } from 'apps/carrier/utils/actions/carrierVins'
import { IStore } from 'apps/carrier/utils/reducers'
import { EditVinsDialog } from './EditVinsDialog'
import { VinGrid } from './VinGrid'

interface ISelector extends ICarrierVinState {
  carrierId?: string
}

export const Vins = () => {
  const { carrierId, error, loading, vins, vinsBackup } = useSelector<IStore, ISelector>(
    ({ carrier: { carrierDetails }, carrierVins }) => ({
      carrierId: carrierDetails?.id,
      ...carrierVins,
    })
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (carrierId && !vins.length) {
      dispatch(getCarrierVins(carrierId))
    }
  }, [carrierId])

  const showDialog = () => dispatch(showVinsDialog())

  const ready = !loading && !error
  return (
    <Card>
      <div className='row pv4 ml0'>
        <Typography variant='h3' className='fl mb0 mt2'>
          Scheduled VINs
        </Typography>
        {ready && (
          <div className='fr'>
            <IconButton
              Icon={EditIcon}
              color='tertiary'
              onClick={showDialog}
              data-test='edit-button'
              label='Edit'
              size='large'
            />
          </div>
        )}
      </div>

      {loading && <Spinner />}
      {error && <InlineMessage message={error} type={INLINE_MESSAGE_VARIANTS.ALERT} />}
      {ready && <VinGrid vins={vinsBackup || vins} />}

      {carrierId && <EditVinsDialog carrierId={carrierId} vins={vins} />}
    </Card>
  )
}
